export const arraysEqual = (a: [], b: []) => {
  if (a === b) return true
  if (a == null || b == null) return false
  if (a.length !== b.length) return false

  for (var i = 0; i < a.length; ++i) {
    if (a[i] !== b[i]) return false
  }
  return true
}

export const calcTotalCost = (original: number, isMyCareMember: boolean, discountCodesValue: number) => {
  let codeValue = 0
  let myCareValue = 0

  if (discountCodesValue) {
    codeValue = original * (discountCodesValue / 100)
  }

  if (isMyCareMember) {
    myCareValue = (original * 0.1)
  }

  const total = original - codeValue - myCareValue

  return `$${total.toLocaleString(undefined, { maximumFractionDigits: 0 })}`
}
